export default __webpack_public_path__ + "static/media/save.ded12ba3.svg";